export var VerificationType;
(function (VerificationType) {
    /** Validates that the PAN is active and valid at the Card Issuer. */
    VerificationType["CARD"] = "CARD";
    /** Card Issuer verification of the Cardholder. */
    VerificationType["CARDHOLDER"] = "CARDHOLDER";
    /** Verification method used to verify the Consumer credential. */
    VerificationType["CONSUMER"] = "CONSUMER";
    /** Verification method used to verify Consumer Device information. */
    VerificationType["DEVICE"] = "DEVICE";
    /** Verification method used to verify information associated with the relationship. */
    VerificationType["RELATIONSHIP"] = "RELATIONSHIP";
})(VerificationType || (VerificationType = {}));
//# sourceMappingURL=VerificationType.js.map